module.exports = __webpack_public_path__ + "static/media/img_1.295aed0a.png";